<template>
    <h5>All Existing Metrics</h5>
    <div class="card">
        <Button label="Create New Metric" @click="createNewMetric" :disabled="!checkUserPermission(UserPermissions.WRITE_METRIC)" />
    </div>
    <!-- metrics table goes below here -->
    <metric-table :reloadTable="state.reloadTable" />
</template>

<script setup>
import { reactive } from 'vue';
import { useRouter } from 'vue-router';
// import AddBasicInfo from '@/components/metrics/components/AddBasicInfo.vue';
import MetricTable from '@/components/metrics/MetricTable.vue';

import { UserPermissions } from '../../enums';
import useUserComposable from '@/composables/UserComposable';
const { checkUserPermission } = useUserComposable();

const router = useRouter();

function createNewMetric() {
    router.push({ name: 'CreateMetric' });
}

const createInitialState = () => {
    return reactive({
        addMetricDialog: false,
        submitBasicInfo: false,
        addDetailsFlag: false,
        reloadTable: false,
    });
};

const state = createInitialState();

/*
const addOtherInfo = async (detailsFlag) => {
    // set filters flag
    state.addDetailsFlag = detailsFlag;
    // triggers submission of basic info in AddBasicInfo component
    state.submitBasicInfo = true;
};

const basicInfoSubmitted = (data) => {
    if (data && data?.id) {
        // hide dialog if basic info has been submitted
        state.addMetricDialog = false;
        // checks if addDetailsFlag is true or false and redirects users accordingly
        if (state.addDetailsFlag) {
            // redirect user to another page with newly created metric to further update the details
            router.push({ name: 'AddMetric', params: { id: data?.id } });
        }
    }

    // reload the table if user just creates the basic info
    state.reloadTable = !state.reloadTable;
    // set submitBasicInfo flag to false
    state.submitBasicInfo = false;
};
 */
</script>

<style lang="scss" scoped></style>
